import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageQuestionFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M20 2H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h2v6a1 1 0 0 0 .61.92A1.1 1.1 0 0 0 8 27a1 1 0 0 0 .7-.29L15.41 20H20a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m-7.73 13.08a.89.89 0 1 1 .92-.89.89.89 0 0 1-.92.89M14 10.93c-.71.41-.93.65-1 1.12a.67.67 0 0 1-.75.57.67.67 0 0 1-.76-.67v-.05a1.69 1.69 0 0 1 1-1.57c.72-.42.94-.69.94-1.2a.94.94 0 0 0-1.06-.88 1.09 1.09 0 0 0-1.11.83.69.69 0 0 1-.72.47.62.62 0 0 1-.7-.67 1.6 1.6 0 0 1 .06-.38 2.54 2.54 0 0 1 2.58-1.56c1.6 0 2.67.88 2.67 2.14A2 2 0 0 1 14 10.93" />
    <path d="M27 5h-1a1 1 0 0 0 0 2h1a1 1 0 0 1 1 1v11.57A1.43 1.43 0 0 1 26.57 21H25a1.8 1.8 0 0 0-.4 0l-.17.05-.2.06-.24.13h-.09a2 2 0 0 0-.28.23 2 2 0 0 0-.24.29 2.4 2.4 0 0 0-.22.45.6.6 0 0 0 0 .12A1.8 1.8 0 0 0 23 23v3.59l-.73-.72-3.5-3.5a1 1 0 0 0-1.41 1.42l5.93 5.94a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .54-.54A1 1 0 0 0 25 29v-6h2a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3" />
  </svg>
);
const ForwardRef = forwardRef(IconMessageQuestionFilledSVG);
ForwardRef.displayName = "IconMessageQuestionFilled";
export { ForwardRef as IconMessageQuestionFilled };
